export default __webpack_public_path__ + "static/media/notification.c12e1673.svg";